<template>
  <div class="station-info-container">

    <ContentTitle>Glass Production Station</ContentTitle>
    <ContentSubTitle><span v-html="appCopyrightInfo" /></ContentSubTitle>
    <FormRow label="Version">
      <FormStaticLabel>{{appVersion}}</FormStaticLabel>
    </FormRow>
    <FormRow label="User">
      <FormStaticLabel>{{profileName}}</FormStaticLabel>
    </FormRow>
    <div class="row">
      <div class="col-4">
        <FormButton class="btn-default btn-block" @click="logout">Logout</FormButton>
      </div>
    </div>
  </div>
</template>

<style scoped>
.station-info-container {
  width: 100%;
  height: 100%;
  flex: 100%;
  position: relative;
  flex-direction: column;
  align-items: stretch;
  padding: 2rem;
}
</style>

<script>
export default {
  name: 'StationInfoPageView',
  components: {
  },
  props: {
    productionStationId: Number
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    profileName() {
      return this.$store.state.profile.profileUser.name
    },
    appVersion() {
      return this.$store.state.system.appVersion
    },
    appCopyrightInfo() {
      return this.$store.state.system.appCopyrightInfo
    },
  },
  mounted() {
  },
  methods: {
    logout(event) {
      this.$authService.clearAuthSession();
      this.$store.commit("profile/clearProfile")
      this.$store.commit("account/clearAccountData")
      this.$router.push("/login");
    },

  }
}
</script>